"use client";

export const dynamic = 'force-dynamic';

import { useEffect, useState } from "react";

export default function SessionsPage() {
  const [sessions, setSessions] = useState<any[]>([]);
  const [taskFilter, setTaskFilter] = useState("");

  async function load() {
    let url = '/api/terminal-sessions';
    if (taskFilter) url += `?taskId=${encodeURIComponent(taskFilter)}`;
    const res = await fetch(url);
    const data = await res.json();
    setSessions(data.sessions || []);
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div style={{ padding: 20 }} className="dashboard-container">
      <h1>Terminal Sessions</h1>
      <div className="mb-4 flex space-x-2">
        <input
          className="border px-2 py-1 rounded"
          placeholder="filter by taskId"
          value={taskFilter}
          onChange={(e) => setTaskFilter(e.target.value)}
        />
        <button className="bg-blue-500 text-white px-3 py-1 rounded" onClick={load}>Filter</button>
      </div>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Task</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">tmux</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {sessions.map((s) => (
            <tr key={s.id} className="hover:bg-gray-100">
              <td className="px-6 py-4 whitespace-nowrap">{s.id}</td>
              <td className="px-6 py-4 whitespace-nowrap">{s.taskId}</td>
              <td className="px-6 py-4 whitespace-nowrap">{s.status}</td>
              <td className="px-6 py-4 whitespace-nowrap">{s.tmuxSession}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button className="text-blue-600 hover:underline" onClick={() => window.open(`/dashboard/terminal?session=${s.id}`, '_blank')}>Open</button>
                <button className="text-blue-600 hover:underline ml-2" onClick={() => window.open(`/dashboard/terminal?session=${s.id}&replay=1`, '_blank')}>Replay</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
